import axios from "axios";
import Strapi from "strapi-sdk-js";

// Backend base URL
// In development (when served from localhost), use relative URLs to leverage CRA's proxy and avoid CORS/cert issues.
// In production, use the public API domain.
export const baseBackendUrl =
    typeof window !== 'undefined' && window.location.hostname === 'localhost'
        ? ''
        : 'https://cogcincinnati.org';

export const getBackend = () => {

    axios.defaults.baseURL = baseBackendUrl || undefined;
    axios.defaults.withCredentials = true;
    return axios;
}

export const getCMS = () => {


    axios.defaults.baseURL = baseBackendUrl;

    return axios;
}